import * as React from 'react';
import { SavingState } from 'api/savingState';
import { formStyles } from 'styles/formStyles';
import { DatePicker, DayOfWeek } from '@fluentui/react/lib/DatePicker';
import { datePickerStrings, onFormatDate } from 'utils/datePickerStrings';
import { IconButton } from '@fluentui/react';
import { defaultSmDate } from 'utils/formatter';
import moment from 'moment-timezone';

export interface FormDatePickerOptions {
    disabled?: boolean;
    required?: boolean;
}

interface FormDatePickerProps {
    label?: string;
    placeholder?: string;
    value?: string;
    onChange: (newValue: string) => void;
    savingState?: SavingState;
    options?: FormDatePickerOptions;
}

export const FormDatePicker: React.FC<FormDatePickerProps> = ({
    label,
    placeholder,
    value,
    options,
    savingState,
    onChange,
}) => {
    return (
        <DatePicker
            label={label}
            placeholder={placeholder}
            disabled={options?.disabled || savingState === SavingState.saving}
            className={formStyles.datePicker}
            firstDayOfWeek={DayOfWeek.Monday}
            strings={datePickerStrings}
            textField={{
                required: false,
                inputClassName: '',
                onRenderSuffix: () =>
                    options?.required ? (
                        <div style={{ marginRight: 12, width: 15, height: 15 }} />
                    ) : (
                        <IconButton
                            onClick={() => {
                                onChange(defaultSmDate);
                            }}
                            iconProps={{ iconName: 'Clear', style: { fontSize: 10 } }}
                            style={{ marginRight: 28, width: 15, height: 15 }}
                        />
                    ),
                styles: { suffix: { padding: '0 4px' } },
            }}
            value={value && value !== defaultSmDate ? moment(value).toDate() : undefined}
            formatDate={onFormatDate}
            styles={{
                root: {
                    marginBottom: 0,
                },
                callout: {
                    selectors: {
                        '& .ms-DatePicker-goToday': { marginLeft: 196 },
                    },
                },
            }}
            onSelectDate={(newValue) => {
                onChange(newValue ? moment(newValue).format('YYYY-MM-DD') + 'T00:00:00' : defaultSmDate);
            }}
        />
    );
};
